/**
 * uiEffects.js — UI Effect Executors (3 types)
 *
 * Non-mutating effects that produce UI side-effects:
 * toast notifications, tab switching, and local dice rolls.
 *
 * These never modify context.character — they return metadata
 * for the caller to handle.
 *
 * Part of the Composable Mechanic Engine (Issue #82, Phase A: #175)
 */

// ─── UI Effect Executors ────────────────────────────────────────────────────

export const UI_EFFECT_EXECUTORS = {
  /**
   * Show a toast notification.
   * effect: { type: 'show_toast', message, icon?, duration?, toastType? }
   */
  show_toast: (effect) => {
    return {
      characterMutated: false,
      toasts: [{
        message: effect.message,
        icon: effect.icon || null,
        duration: effect.duration || 3000,
        type: effect.toastType || 'success',
      }],
    };
  },

  /**
   * Switch the active tab in the parent component.
   * effect: { type: 'switch_tab', tab }
   */
  switch_tab: (effect) => {
    return {
      characterMutated: false,
      tabSwitch: effect.tab,
    };
  },

  /**
   * Trigger a local dice roll animation.
   * effect: { type: 'roll_local_dice', dice, label? }
   */
  roll_local_dice: (effect) => {
    return {
      characterMutated: false,
      localDiceRoll: {
        dice: effect.dice,
        label: effect.label || 'Roll',
      },
    };
  },
};
